<template>
  <div class="flex items-center gap-8">
    <NuxtLink
      external
      target="_blank"
      rel="nofollow"
      :to="getDocUrl('MrCanceller_Whitepaper.pdf')"
      class="flex gap-2 items-center document-link"
      :aria-label="getContent('app.document_link_1_paper_aria_label')"
    >
      <AppIcon name="document_icon" />
      <span class="content-text">
        {{ getContent('app.document_link_1') }}
      </span>
    </NuxtLink>
    <NuxtLink
      external
      rel="nofollow"
      target="_blank"
      :to="getDocUrl('MrCanceller_Lightpaper.pdf')"
      class="flex gap-2 items-center document-link"
      :aria-label="getContent('app.document_link_2_paper_aria_label')"
    >
      <AppIcon name="document_icon" />
      <span class="content-text">
        {{ getContent('app.document_link_2') }}
      </span>
    </NuxtLink>
    <div
      v-click-outside="closeDropdown"
      class="relative"
    >
      <button
        type="button"
        class="flex gap-2 items-center document-link"
        :aria-label="getContent('app.document_link_3_paper_aria_label')"
        @click="toggleDropdown"
      >
        <AppIcon name="document_icon" />
        <span class="content-text">
          {{ getContent('app.document_link_3') }}
        </span>
        <AppIcon
          size="6"
          name="arrow_icon"
          :class="[
            'arrow-icon',
            isDropdownOpen ? 'rotated' : '',
          ]"
        />
      </button>
      <Transition>
        <div
          v-if="isDropdownOpen"
          class="document-dropdown bg-blur"
        >
          <a
            v-for="(item, index) in dropdownItems"
            :key="index"
            class="document-dropdown-item content-text"
            :href="getDocUrl(item.file)"
            target="_blank"
            rel="nofollow"
          >
            {{ getContent(item.labelKey) }}
          </a>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentLinks',
  data: () => ({
    isDropdownOpen: false,
    dropdownItems: [
      {
        file: 'Mr_Canceller_jeDAO_Protocol_Audit_V1_0.pdf',
        labelKey: 'app.document_link_3_item_1'
      },
      {
        file: 'Mr_Canceller_jeDAO_Protocol_Audit_V1_1.pdf',
        labelKey: 'app.document_link_3_item_2'
      },
    ]
  }),
  methods: {
    getDocUrl(filename) {
      const { cdnBaseUrl } = useRuntimeConfig().public
      return `${cdnBaseUrl}/docs/${filename}`
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
    },
    closeDropdown() {
      this.isDropdownOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>

.document-link {
  background: transparent;
  border: none;
  outline: none;
  user-select: none;
  cursor: pointer;

  &:hover {
    .content-text {
      color: $yellow-100;
    }
  }
}
.document-dropdown {
  position: absolute;
  z-index: 10;
  padding: 16px;
  border-radius: 16px;

  .document-dropdown-item {
    display: block;
    margin-bottom: 8px;

    &:hover {
      color: $yellow-100;
    }
  }
}
</style>
